import Resource from './Resource';

export default class {
    constructor() {
        this.Resource = new Resource()
    }

    async connect (
        websiteId,
        connectionId,
        accountId,
        propertyId,
        measurementId,
        apiSecret,
        isEnabledLPTracking,
        cronTime,
        pageDataOption
    ) {
        return await this.Resource.connect(websiteId, connectionId, accountId, propertyId, measurementId, apiSecret, isEnabledLPTracking, cronTime, pageDataOption)
    }

    async updateConnection (websiteId, isEnabledLPTracking, cronTime, pageDataOption) {
        return await this.Resource.updateConnection(websiteId, isEnabledLPTracking, cronTime, pageDataOption)
    }

    async reconnect (websiteId, connectionId, accountId, propertyId, measurementId, apiSecret) {
        return await this.Resource.reconnect(websiteId, connectionId, accountId, propertyId, measurementId, apiSecret)
    }

    async receiveAccounts() {
        return await this.Resource.receiveAccounts()
    }

    async receiveProperties(connectionId, accountId) {
        return await this.Resource.receiveProperties(connectionId, accountId)
    }

    async receiveMeasurements(connectionId, propertyId) {
        return await this.Resource.receiveMeasurements(connectionId, propertyId)
    }
}
